import * as types from '../../mutation-types';
import * as model from '../../../comm/model/';
import { getApi } from '../../../comm/middleware/callApi';
import apis from '../../../comm/api/apis';

// 专家端问题列表接口
export const getQuestionList = ({ commit }, { expertid, type, curpage, pagesize }) => {
  return getApi({ commit }, apis.getQuestionList, { expertid, type, curpage, pagesize })
    .then((body) => {
      return body.data;
    });
};
// 专家端服务设置接口
export const getExpertJobSetting = ({ commit }, { expertids, hascount, hasexpertsetting }) => {
  return getApi({ commit }, apis.expertJobSetting, { expertids, hascount, hasexpertsetting })
    .then((body) => {
      return body.data;
    });
};
// 专家服务信息修改
export const updateExpertModify = ({ commit }, { servicecount, servicetime, jobsetting }) => {
  return getApi({ commit }, apis.updateExpertModify, { servicecount, servicetime, jobsetting })
    .then((body) => {
      return body.data;
    });
};
// 已完成订单查询IM历史消息
export const getQusetionDialog = ({ commit }, { questionId, expertId, userType, pageNo, pageSize }) => {
  return getApi({ commit }, apis.qusetionDialog, { questionId, expertId, userType, pageNo, pageSize })
    .then((body) => {
      const imMsgInfo = model.IMMsg(body.data);
      commit(types.AJAX_GET_IMMESGINFO, { imMsgInfo });
      return imMsgInfo;
    });
};

//  进入IM聊天时，获取聊天室相关信息
export const getQuestionInfo = ({ commit }, { questionId, expertId }) => {
  return getApi({ commit }, apis.questionInfo, { questionId, expertId })
    .then((body) => {
      return body.data;
    });
};

// 预发送消息校验接口
export const bindDialog = ({ commit }, { questionId, expertId, msgType }) => {
  return getApi({ commit }, apis.bindDialog, { questionId, expertId, msgType })
    .then((body) => {
      return body.data;
    });
};

// 取消，接单拒单，完成
export const saveQuestionStatus = ({ commit }, { questionId, expertId, userType, status, remark }) => {
  return getApi({ commit }, apis.saveQuestionStatus, { questionId, expertId, userType, status, remark })
    .then((body) => {
      return body.data;
    });
};

// 专家个人中心专家信息
export const getExpertInfo = ({ commit }, { expertid }) => {
  return getApi({ commit }, apis.expertInfo, { expertid })
    .then((body) => {
      return body.data;
    });
};

// 专家个人中心专家结算信息
export const getSettleInfo = ({ commit }, { expertid }) => {
  return getApi({ commit }, apis.settleInfo, { expertid })
    .then((body) => {
      return body.data;
    });
};

// 年份获取
export const getYearParam = ({ commit }) => {
  return getApi({ commit }, apis.yearParam)
    .then((body) => {
      return body.data;
    });
};

// 专家结算单列表
export const getSettleList = ({ commit }, { supplierid, expertid, infotype, year }) => {
  return getApi({ commit }, apis.settleList, { supplierid, expertid, infotype, year })
    .then((body) => {
      return body.data;
    });
};

// 获取结算单明细
export const getOrderDetail = ({ commit }, { supplierid, expertid, billmonth, settlecode, email }) => {
  return getApi({ commit }, apis.orderDetail, { supplierid, expertid, billmonth, settlecode, email })
    .then((body) => {
      return body.data;
    });
};



// WEBPACK FOOTER //
// ./src/store/expert/expertAnswer/actions.expertAnswer.js